import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageSStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M15.2099 6.85V6.71C15.2099 4.94 13.7699 3.5 11.9999 3.5C10.2299 3.5 8.78994 4.94 8.78994 6.71V6.85C6.78994 7.98 5.43994 10.12 5.43994 12.57V19.27C5.43994 20.58 6.50994 21.65 7.81994 21.65H16.1899C17.4999 21.65 18.5699 20.58 18.5699 19.27V12.57C18.5699 10.12 17.2199 7.98 15.2199 6.85H15.2099ZM11.9999 4.9C12.8399 4.9 13.5399 5.47 13.7499 6.24C13.1899 6.09 12.6099 6 11.9999 6C11.3899 6 10.8099 6.08 10.2499 6.24C10.4599 5.47 11.1599 4.9 11.9999 4.9ZM6.83994 16.29C8.14994 15.44 10.0099 14.95 11.9999 14.95C13.9899 14.95 15.8399 15.44 17.1599 16.29V19.27C17.1599 19.81 16.7199 20.24 16.1899 20.24H7.81994C7.27994 20.24 6.84994 19.8 6.84994 19.27V16.29H6.83994ZM17.1599 14.67C15.7199 13.94 13.8999 13.54 11.9999 13.54C10.0999 13.54 8.28994 13.94 6.83994 14.67V12.57C6.83994 9.73 9.14994 7.41 11.9999 7.41C14.8499 7.41 17.1599 9.72 17.1599 12.57V14.67Z"
				fill="currentColor"
			/>
			<path
				d="M13.2599 10.19H10.7499C10.3599 10.19 10.0499 10.51 10.0499 10.89C10.0499 11.27 10.3699 11.59 10.7499 11.59H13.2599C13.6499 11.59 13.9599 11.27 13.9599 10.89C13.9599 10.51 13.6399 10.19 13.2599 10.19Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageSStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageSStrokeIcon;
